import './Home.css'

function Home() {
    return (
        <div className="Home">
            <div className="HomeTitle">
                <p>{"Seismic and Structural Health Monitoring for Dams"}</p>
            </div>
            {/* <img src={logo} className="Home-logo" /> */}
            <footer>
                <cite>
                    <a
                        title="Foto: Martina Nolte"
                        href="https://commons.wikimedia.org/wiki/File:SQK_Dam_DSC_3657.jpg"
                    >
                        Martina Nolte
                    </a>
                </cite>
            </footer>
                <a href='/map' className='button home-btn'>Enter</a>
        </div>
    );
}

export default Home;